<!--
soho-busyindicator needed here for paging.
-->
<div soho-busyindicator
    [style.height]="'100%'"
    [text]="' '"
    [blockUI]="true"
    [displayDelay]="20"
    [timeToComplete]="this.uiLoadingIndicatorTimeout"
    [transparentOverlay]="true"
>
  <ng-container *ngIf="!showEmptyMessage; else ShowEmptyDataMessage">
  <!-- USE FLEX LAYOUT -->
  <div class="scrollable-flex">
    <!-- FLEX CONTENT AREA -->
    <!--
    Setting class.card when list-view is in the main content causes it to display
    a little more like a grid. This is what we want in the case where the list-view
    is the end point of a screen.
    ---
    Examples: page panes, page panels, detail sections, etc..
    The only place we don't want this is if it's a cardList with detail sections.
    ---
    image-list class is for lazy loading images in the list view that scroll
    into view. The image-list is the observable that ngx-lazy-load-images will
    use to decide when an img element is in view then load that image lazily.
    -->
    <!-- taking out 'lazy-load-images' directive tag because images are not lazy loading on iOS -->
    <div class="scrollable-flex-content image-list" [style.overflow]="'auto'" [class.card]="showAsCard">
      <soho-listview
          #SohoListView
          selectable='{{selectionMode}}'
          disableItemDeactivation="'true'"
          [attr.data-automation-id]="listViewAutomationId"
          (keydown)="onKeyDown($event)"
          (selected)="onItemsSelected($event)"
          (unselected)="onItemUnselected($event)"
          (itemactivated)="onItemActivated($event)"
          (itemdeactivated)="onItemDeactivated($event)"
          (click)="onItemClicked($event)"
          (dblclick)="onItemDoubleClicked($event)"
          (contextmenu)="onContextMenu($event)"
      >
        <li soho-listview-item
            *ngFor="let data of dataViewSet?.data"
            [attr.draggable]="implementsDragAndDrop ? 'true' : 'false'"
            (dragstart)="onDragged($event, data)"
            (dragend)="onDragEnd($event, data)"
        >
          <lm-list-card
              [listSpec]="_listSpec"
              [dataView]="data"
              (uiLinkEvent)="onUILinkEvent($event)"
              (toolbarButtonEvent)="onToolbarButtonEvent($event)">
          </lm-list-card>
        </li>
        <div soho-emptymessage *ngIf="showEmptyMessage"
            style="display:initial"
            [emptyMessageOptions]="emptyMessage"
        ></div>
      </soho-listview>
    </div>

    <!-- FLEX FOOTER -->
    <div class="scrollable-flex-footer">
      <div soho-standalone-pager *ngIf="!hidePagerBar"
        id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
        [attributes]="pagerIdAttributes"
        [smallPageSizeSelector]="true"
        [pageSizeMenuSettings]="{ attachToBody: true }"

        [enableFirstButton]="hasFirstPage"
        [enablePreviousButton]="hasPreviousPage"
        [enableNextButton]="hasNextPage"
        [enableLastButton]="hasLastPage"

        [firstPageTooltip]="firstPageButtonTooltip"
        [previousPageTooltip]="previousPageButtonTooltip"
        [nextPageTooltip]="nextPageButtonTooltip"
        [lastPageTooltip]="lastPageButtonTooltip"

        [showPageSizeSelector]="showPageSizeSelector"
        [pageSize]="pageSize"
        [pageSizes]="pageSizes"

        (firstPage)="onFirstPage($event)"
        (previousPage)="onPreviousPage()"
        (nextPage)="onNextPage()"
        (lastPage)="onLastPage()"
        (pageSizeChange)="onPageSizeChange($event)"
      ></div>
      <div class="pager-toolbar collapse-button" *ngIf="showCollapseButton$ | async">
        <button id="collapse-button"
          soho-button="icon"
          icon="collapse-app-tray"
          [ripple]="false"
          (click)="collapseList()">
        </button>
      </div>
    </div>

  </div>
  </ng-container>
  <ng-template #ShowEmptyDataMessage>
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  </ng-template>
</div>
<div #modalPlaceholder id="modalPlaceholder"></div>
